var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticClass:"w-100",attrs:{"data":_vm.listResult}},[_c('el-table-column',{attrs:{"property":"name","label":"Name","width":"350px"}}),_c('el-table-column',{attrs:{"property":"result","label":"Result","width":"280px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }